import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './features/page-not-found/page-not-found.component';
import HomeComponent from './features/home/home.component';
import AboutComponent from './features/about/about.component';
import { ServicesComponent } from './features/services/services.component';
import { CheckCalculatorComponent } from './features/check-calculator/check-calculator.component';
import { ConsultoriaFiscalComponent } from './features/services/consultoria-fiscal/consultoria-fiscal.component';
import { FinanciamientoComponent } from './features/services/financiamiento/financiamiento.component';
import { TesoreriaComponent } from './features/services/tesoreria/tesoreria.component';
import { ExternalCfoComponent } from './features/services/external-cfo/external-cfo.component';
import { CapacitacionComponent } from './features/services/capacitacion/capacitacion.component';
import { ComexComponent } from './features/services/comex/comex.component';
import { ServiciosEspecializadosComponent } from './features/services/servicios-especializados/servicios-especializados.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'about',
    component: AboutComponent,
  },
  {
    path: 'servicios',
    component: ServicesComponent, // Componente general (opcional, puede ser un layout o hero)
    children: [
      { path: '', redirectTo: 'financiamiento', pathMatch: 'full' }, // Redirección por defecto
      { path: 'financiamiento', component: FinanciamientoComponent },
      { path: 'tesoreria', component: TesoreriaComponent },
      { path: 'external-cfo', component: ExternalCfoComponent },
      { path: 'capacitacion', component: CapacitacionComponent },
      { path: 'comex', component: ComexComponent },
      { path: 'consultoria-fiscal', component: ConsultoriaFiscalComponent },
      { path: 'servicios-especializados', component: ServiciosEspecializadosComponent },
    ]
  },
  {
    path: 'calculadora-cheques',
    component: CheckCalculatorComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];